import {updateCachedDirectoryAddress} from './get-directory-addresses';
import {api} from 'services/api';
import {Address} from 'types/address';
import {ObjectId} from 'types/object-id';
import {Option} from 'types/option';
import {ResponseData} from 'types/response-data';

const storeAddress = api.injectEndpoints({
  endpoints: builder => ({
    storeAddress: builder.mutation<Response, StoreAddressRequest>({
      query: params => {
        return {
          method: 'POST',
          url: `directories/${params.id}/addresses`,
          body: {
            address_type: params.address_type?.id,
            city: params.city,
            comment: params.comment,
            label: params.label,
            country: params.country?.id,
            first_line: params.first_line,
            force_vat: params.force_vat,
            no_vat: params.no_vat,
            vat_mode: params.vat_mode?.value,
            second_line: params.second_line,
            third_line: params.third_line,
            zip_code: params.zip_code,
            is_default: params.is_default,
          },
        };
      },
     // @ts-ignore
     invalidatesTags: (result, error, arg) => [ { type: 'DirectoryAddresses', id: arg.directory_id } ]
      ,
    }),
  }),
});

export type StoreAddressRequest = {
  address_type?: any;
  label?: string;
  city?: string;
  comment?: string;
  country?: Option;
  first_line?: string;
  force_vat?: boolean;
  id?: ObjectId;
  no_vat?: boolean;
  vat_mode?: Option;
  second_line?: string;
  third_line?: string;
  zip_code?: string;
  is_default?: boolean;
};

type Response = ResponseData<Address>;

export const {useStoreAddressMutation} = storeAddress;
